<template>
    <BCard class="border border-0 comunityCard">
        <ImageWithFallback :src="data.imageFile" class="comunityCard__img" />
        <BCardTitle class="font-weight-bold comunityCard__title mt-3 fs-3">
            <u>{{ data?.name }}</u>
        </BCardTitle>
        <BCardText class="comunityCard__description" v-html="formattedText">
        </BCardText>
    </BCard>
</template>
<script>
    import "../assets/scss/index.scss";
    import ImageWithFallback from "@/components/ImageWithFallback.vue";

    export default {
        props: {
            data: Object,
        },
        components: {
            ImageWithFallback,
        },
        computed: {
            formattedText() {
                return this.data?.extra?.replace(/\n/g, "<br>");
            },
        },
    };
</script>
<style lang="scss"></style>
